var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUwalk11(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 114,
    viewBox: "0 0 115 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_390_4025)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 12,
    width: 87,
    height: 87,
    rx: 3.40448,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.7613 31.7072C64.0824 31.925 55.9469 26.0239 50.3194 26.1303C44.6919 26.2367 32.9302 29.694 33.4149 55.5852C33.8996 81.4764 49.8718 84.9792 56.0634 84.8643C85.0504 84.3222 96.4473 31.3204 75.7613 31.7072Z",
    fill: "url(#paint0_linear_390_4025)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.291 35.1523H86.6689V36.8413H83.291V35.1523Z",
    fill: "#D4D8FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5791 35.1523H76.9569V36.8413H73.5791V35.1523Z",
    fill: "#D4D8FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4893 29.2422H81.1782V32.62H79.4893V29.2422Z",
    fill: "#D4D8FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4893 38.9531H81.1782V42.331H79.4893V38.9531Z",
    fill: "#D4D8FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8674 77.3744C29.4706 77.3744 28.334 76.2377 28.334 74.841C28.334 73.4443 29.4706 72.3076 30.8674 72.3076C32.2641 72.3076 33.4008 73.4443 33.4008 74.841C33.4008 76.2377 32.2641 77.3744 30.8674 77.3744ZM30.8674 73.9965C30.4012 73.9965 30.0229 74.3765 30.0229 74.841C30.0229 75.3055 30.4012 75.6855 30.8674 75.6855C31.3335 75.6855 31.7118 75.3055 31.7118 74.841C31.7118 74.3765 31.3335 73.9965 30.8674 73.9965Z",
    fill: "#D4D8FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4771 73.1458H52.0269C51.7285 73.1458 51.4863 72.4766 51.4863 71.652C51.4863 70.8274 51.7285 70.1582 52.0269 70.1582H62.4771C62.7755 70.1582 63.0176 70.8274 63.0176 71.652C63.0176 72.4766 62.7755 73.1458 62.4771 73.1458Z",
    fill: "#433ED1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.6665 56.9933C59.2156 56.9933 61.2821 55.0281 61.2821 52.6039C61.2821 50.1796 59.2156 48.2144 56.6665 48.2144C54.1174 48.2144 52.0509 50.1796 52.0509 52.6039C52.0509 55.0281 54.1174 56.9933 56.6665 56.9933ZM56.6665 60.3015C61.1368 60.3015 64.7607 56.8551 64.7607 52.6039C64.7607 48.3526 61.1368 44.9062 56.6665 44.9062C52.1962 44.9062 48.5723 48.3526 48.5723 52.6039C48.5723 56.8551 52.1962 60.3015 56.6665 60.3015Z",
    fill: "#433ED1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.728 60.8431L56.9129 55.8485L59.2444 53.3934L65.0595 58.388L62.728 60.8431Z",
    fill: "#433ED1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0694 78.9223H46.4348C43.3091 78.9223 40.7686 76.4665 40.7686 73.445V36.5975C40.7686 33.576 43.3091 31.1201 46.4348 31.1201H68.0694C71.1951 31.1201 73.7356 33.576 73.7356 36.5975V43.0707H70.6449V36.5975C70.6449 35.2251 69.489 34.1078 68.0694 34.1078H46.4348C45.0151 34.1078 43.8592 35.2251 43.8592 36.5975V73.445C43.8592 74.8173 45.0151 75.9347 46.4348 75.9347H68.0694C69.489 75.9347 70.6449 74.8173 70.6449 73.445V62.9882H73.7356V73.445C73.7356 76.4665 71.1951 78.9223 68.0694 78.9223Z",
    fill: "#433ED1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6484 63.0399V43.0742H73.7309V63.0399H70.6484Z",
    fill: "#433ED1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_390_4025",
    x: 0.722534,
    y: 0.0843256,
    width: 113.555,
    height: 113.555,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.36179
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.63873
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_390_4025"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_390_4025",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_390_4025",
    x1: 59.8564,
    y1: 26.1289,
    x2: 59.8564,
    y2: 84.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F2FF",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUwalk11);
export default __webpack_public_path__ + "static/media/uwalk11.373cbfb89bac04ae426f5048609e2859.svg";
export { ForwardRef as ReactComponent };